<template>
    <transition appear name="appear-left">
        <div id="logo"><a a href="#" v-scroll-to="'#home'">Tobi<br>Hoffmann</a></div>
    </transition>
</template>

<script>
    export default {
        name: "Logo"
    }
</script>

<style lang="css" scoped>
    #logo {
        position: fixed;
        top: 1.4rem;
        left: 1.4rem;
        width: auto;
        z-index: 2;
        font-size: 1.4rem;
        line-height: 1.6rem;
        font-weight: 700;
    }

    #logo a {
        color: rgba(86, 86, 86, 1);
    }

    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 600px)
    and (-webkit-min-device-pixel-ratio: 2) {
        #logo {
            font-size: 1rem;
            line-height: 1.2rem;
            top: 1.1rem;
            left: 2rem;

        }
    }
</style>
